export default function PleaseWait() {
   return (
      <div className='vh-100 align-items-center justify-content-center d-flex p-4' style={{ backgroundColor: '#58c3c1' }}>
         <div className='headline-2'>Please wait...</div>
         <div><img src='/wait-transparent.gif' /></div>
      </div>
   )
}